import { render, staticRenderFns } from "./Participate.vue?vue&type=template&id=3230830e&scoped=true&"
var script = {}
import style0 from "./Participate.vue?vue&type=style&index=0&id=3230830e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230830e",
  null
  
)

export default component.exports